module.exports = __webpack_public_path__ + "static/media/RentGif.b01a62bd.gif";